import { fromJS } from 'immutable'
import {
  TEAM_CREATE_REQUEST,
  TEAM_CREATE_SUCCESS,
  TEAM_CREATE_FAILURE,
  TEAM_CREATE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case TEAM_CREATE_REQUEST:
      return state
        .set('isFetching', true)
    case TEAM_CREATE_SUCCESS:
      return state
        .set('teamCreate', fromJS(action.payload.createdTeam))
        .set('status', 200)
        .set('message', 'Created Successfully.')
        .set('isFetching', false)
    case TEAM_CREATE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('teamCreate', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case TEAM_CREATE_RESET:
      return state
        .delete('teamCreate')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/team/team-create-reducer.js